import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { customName, getColorFromId } from "../../helpers/commonHelpers";
import { useSelector, useDispatch } from "react-redux";
import {
    getAgendaWithMinutesDetails,
    giveMomWritePermission,
} from "../../redux/actions/meetingActions/MeetingAction";
import LoaderButton from "../Common/LoaderButton";

const AssignedAttendeesModal = React.memo((props) => {
    const dispatch = useDispatch();
    const employeeData = useSelector((state) => state.user);
    const meetingDetails = useSelector((state) => state.meeting);
    const accessToken = localStorage.getItem("accessToken");
    const { attendees, meetingData, attendeeType } = props;
    const [attendeesArray, setAttendeesArray] = useState([]);
    const [formData, setFormData] = useState({
        fromTime: "",
        toTime: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setAttendeesArray(attendees);
        setFormData({
            ...formData,
            fromTime: meetingData?.actualFromTime,
            toTime: meetingData?.actualToTime,
        });
        if (meetingDetails.isAttendanceStatus && accessToken) {
            dispatch(getAgendaWithMinutesDetails(meetingData._id, accessToken));
        }
    }, [
        props.isAttendace,
        props.IsModalOpen,
        meetingDetails.isAttendanceStatus,
        meetingDetails.loading,
    ]);

    return (
        <>
            <Modal
                show={props.IsModalOpen}
                onHide={(e) => props.setIsModalOpen(false)}
                backdrop="static"
            >
                <div className="modal-header attendees-modal">
                    <div>
                        <h4 className="modal-title">Assigned User(s)</h4>
                    </div>

                    <div>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={(e) => props.setIsModalOpen(false)}
                        ></button>
                    </div>
                </div>

                <Modal.Body className="modal-height action-assigned-user">
                    <div className="attendees-popup">
                        {attendeesArray &&
                            attendeesArray.map((attendee, index) => {
                                return (
                                    <div className="attendee-content" key={index}>
                                        {props.loginUserData?.userData?.isMeetingOrganiser ||
                                            props.loginUserData?.userData?.isAdmin ? (
                                            <div className="check-attendee">
                                                <div
                                                    className="attendee1 attendee-list sl attendee-list-circle"
                                                    style={{
                                                        backgroundColor: attendee?.profilePicture ? undefined : getColorFromId(attendee?._id),
                                                        
                                                    }}
                                                >
                                                    {attendee?.profilePicture ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                                            alt=""
                                                            className="attendee-profile-picture icon-image attendee-list-circle-img"
                                                            style={{
                                                              
                                                            }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.display = "none";
                                                                // e.target.parentElement.innerHTML = `<span class="attendee-name">${customName(
                                                                //   attendee?.name
                                                                // )}</span>`;
                                                                // e.target.parentElement.style.backgroundColor = getColorFromId(attendee?._id);
                                                                e.target.parentElement.style.backgroundColor = getColorFromId(
                                                                    attendee?._id
                                                                );
                                                                e.target.parentElement.innerText = customName(
                                                                    attendee?.name
                                                                );
                                                            }}
                                                        />
                                                    ) : (
                                                        customName(attendee.name)
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="attendee-content" key={index}>
                                                <div
                                                    className="attendee1 attendee-list sl attendee-list-circle"
                                                    style={{
                                                        backgroundColor: attendee?.profilePicture ? undefined : getColorFromId(attendee?._id),
                                                        
                                                    }}
                                                >
                                                    {attendee?.profilePicture ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                                                            alt=""
                                                            className="attendee-profile-picture icon-image attendee-list-circle-img"
                                                            style={{
                                                                
                                                            }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.display = "none";
                                                                e.target.parentElement.innerHTML = `<span class="attendee-name">${customName(attendee?.name)}</span>`;
                                                                // e.target.parentElement.style.backgroundColor = getColorFromId(attendee?._id);
                                                            }}
                                                        />
                                                    ) : (
                                                        customName(attendee.name)
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div className="action-cmnt-text">
                                            <p className="detail-name word-break">
                                                {" "}
                                                {attendee?._id?.toString() ===
                                                    props?.meetingData?.createdById?.toString()
                                                    ? attendee.name + " (Organiser)"
                                                    : attendee.isAdmin === true
                                                        ? attendee.name + " (Admin)"
                                                        : attendee.name}
                                            </p>

                                            {attendee?._id?.toString() ===
                                                props?.meetingData?.createdById?.toString() &&
                                                employeeData.userData.isAdmin === true ? (
                                                <p className="name-undertext detail-date-time comment-text word-break">
                                                    {attendee.email}
                                                </p>
                                            ) : (
                                                <>
                                                    {attendeeType && attendeeType == "attendees" ? (
                                                        <p className="name-undertext detail-date-time comment-text word-break">
                                                            {attendee.email}{" "}
                                                            {attendee.empId
                                                                ? " (" + attendee.empId + ") "
                                                                : ""}
                                                        </p>
                                                    ) : attendee.isEmployee == true ? (
                                                        <p className="name-undertext detail-date-time comment-text word-break">
                                                            {attendee.email}{" "}
                                                            {attendee.empId
                                                                ? " (" + attendee.empId + ") "
                                                                : ""}
                                                        </p>
                                                    ) : (
                                                        <>
                                                            <p className="name-undertext detail-date-time  comment-text word-break">
                                                                {attendee.email}{" "}
                                                                {attendee.empId
                                                                    ? " (" + attendee.empId + ") "
                                                                    : " (Guest) "}
                                                            </p>
                                                            {attendee?.designation ? (
                                                                <div className="detail-date-time mt-1 des-comp">
                                                                    <span> Designation -</span>{" "}
                                                                    {attendee.designation}
                                                                </div>
                                                            ) : null}
                                                            {attendee?.role ? (
                                                                <div className="detail-date-time mt-1 des-comp">
                                                                    <span> Role -</span> {attendee.role}
                                                                </div>
                                                            ) : null}
                                                            {attendee?.department ? (
                                                                <div className="detail-date-time mt-1 des-comp">
                                                                    <span> Department -</span>{" "}
                                                                    {attendee.department}
                                                                </div>
                                                            ) : null}
                                                            {attendee?.companyName ? (
                                                                <div className="detail-date-time des-comp">
                                                                    <span> Company Name -</span>{" "}
                                                                    {attendee.companyName}
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
});

export default AssignedAttendeesModal;